module.exports = __webpack_public_path__ + "static/media/lichter_oben.8e15d483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/lichter_oben.png
// module id = 507
// module chunks = 0